<template>
  <div class="foot">
    <div class="flex">
      <p>以上最终内容解释权归格瑞电竞俱乐部所有</p>
    <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2026012759号-1</a> &nbsp;|&nbsp;
    <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">鲁公网安备37010102007052号</a>
    </div>
    </div>
</template>

<script>
export default {
    name: 'footerIndex',  // 修改为多词的组件名称
}
</script>

<style>
.foot {
  font-size: 2.6vw; /* 字体大小使用vw */
  padding: 2vw 5vw;
  color: #8a93a3;
}
.flex{
  justify-content: center;
  margin-top: 2vw;
  text-align: center;
  line-height: 5vw;
}
.foot a {
  color: #8a93a3;
  font-size: 2.2vw; /* 字体大小使用vw */
}

@media (min-width: 1100px) {
  .foot {
    font-size: 60px; /* 这个大小刚好 */
    padding: 40px;
  }
  .flex{
    line-height: 100px;
  }
  .foot a {
    font-size: 48px;
  }
}
</style>